import React from 'react';
import styled from 'styled-components';

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  text-align: center;

  > * {
    color: #000;
  }

  button {
    background: var(--button-bg);
    border: 2px solid var(--button-border);
    padding: 0.3em 0.8em;
    border-radius: 6px;
    color: var(--white);
    cursor: pointer;
    margin-top: 0.4em;
  }
  button:hover {
    background: var(--button-hover);
    border-color: var(--button-hover);
  }
`;

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <ModalWrapper>
      <ModalContent>
        {children}
        <button onClick={onClose}>Ok</button>
      </ModalContent>
    </ModalWrapper>
  );
};

export default Modal;
